export class TrimValueConverter {
  fromView(value) {
    if (!value) {
      return value;
    }
    return value.trim();
  }
}
